
<a id="trusted-google" [href]="'https://www.google.com/preferences/source?q=' + host" target="_blank">
	<div class="container">
		<div id="trusted-google-content">
			<div id="left">
				<img src="assets/images/google-logo.webp" />
				<div>
					<div>Legyen a <b>{{host}}</b> az első számú forrás!</div>
					<div>A Google új funkciója segítségével te döntheted el, melyik lap híreit láthatod legelöl. Kattints a beállításhoz.</div>
				</div>
			</div>
			<span id="button">Beállítom</span>
		</div>
	</div>
</a>